import { render, staticRenderFns } from "./InviteFriends.vue?vue&type=template&id=0e178282&scoped=true"
import script from "./InviteFriends.vue?vue&type=script&lang=js"
export * from "./InviteFriends.vue?vue&type=script&lang=js"
import style0 from "./InviteFriends.vue?vue&type=style&index=0&id=0e178282&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e178282",
  null
  
)

export default component.exports